import {apiUrl} from '@/constants/config';
import {client as http, axiosInstance} from '../../http_client';

export default {
    state: {
        paymentPlanCounts: {}
    },
    getters: {
        paymentPlanCounts: state => state.paymentPlanCounts
    },
    mutations: {

    },
    actions: {
        getPaymentPlanCounts({state}) {
            return new Promise((resolve, reject) => {
                http.get('payment-plans/counts/', {}).then(response => {
                    state.paymentPlanCounts = response.data;
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        }
    }
}
